// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"284":"cb4c68fb","759":"c52d756e"}[chunkId] + ".chunk.css";
};